import { render, staticRenderFns } from "./FactCheckReviewTable.vue?vue&type=template&id=f5966688&"
import script from "./FactCheckReviewTable.vue?vue&type=script&lang=js&"
export * from "./FactCheckReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports